export const ADMIN_PROFILE_SETTINGS_CHANGE_PASSWORD_ROUTE_NAME = Symbol('admin.profile-settings.change-password');
export const AFFILIATE_PROFILE_SETTINGS_CHANGE_PASSWORD_ROUTE_NAME = Symbol('affiliate.profile-settings.change-password');

export const ADMIN_PROFILE_SETTINGS_CHANGE_PASSWORD_SAVE_URL = 'admin/profile/password_update';
export const AFFILIATE_PROFILE_SETTINGS_CHANGE_PASSWORD_SAVE_URL = 'affiliate/settings/password_update';
export const PROFILE_SETTINGS_CHANGE_PASSWORD_SAVE_MUTATION_KEY = 'profile-settings.change-password.save';
